import { buildHref } from "@softmax/web-addresses";
import { coworldMenu, type CoworldNav } from "../coworld-menu";
import { getStartedLink, leavesTheSite, type SiteLink } from "../site-links";
import { siteShape } from "../site-shape";
import { isStartRoom } from "../start-room";

export const browseDoor: SiteLink = {
  label: "Browse",
  href: buildHref({ name: "browse" }),
};

export function navigationDestinations({
  coworld,
  appBar,
  isSignedIn,
  pathname,
}: {
  readonly coworld: CoworldNav | undefined;
  readonly appBar: boolean;
  readonly isSignedIn: boolean;
  readonly pathname: string;
}) {
  const doors: SiteLink[] = [];
  const compactAppBar = appBar && !siteShape.navDoors;

  if (coworld && !compactAppBar) {
    doors.push(browseDoor);

    if (coworld.docs)
      doors.push({
        label: coworld.docs.title,
        href: coworld.docs.href,
        external: leavesTheSite(coworld.docs.href),
      });
  }

  let drawerDoors = doors;

  if (compactAppBar) {
    drawerDoors = [browseDoor];

    if (coworld) drawerDoors.push({ label: "Play", href: coworld.playHref });
  } else if (coworld && isSignedIn) {
    drawerDoors = coworldMenu(coworld);
  }

  const action = navigationAction({ coworld, isSignedIn, pathname });
  return { doors, drawerDoors, action };
}

function navigationAction({
  coworld,
  isSignedIn,
  pathname,
}: {
  readonly coworld: CoworldNav | undefined;
  readonly isSignedIn: boolean;
  readonly pathname: string;
}): SiteLink | null {
  let action: SiteLink | null = getStartedLink;

  if (isSignedIn || (coworld && isStartRoom(pathname))) action = null;
  else if (coworld) action = { label: "Play Now", href: coworld.playHref };

  return action;
}
